import React, {useState} from 'react'
import {Button, Modal, Form} from 'react-bootstrap'
import CKEditor from '../CKEditor/CKEditor'
import {PromptDialog} from '../../components/Dialog/Message';

const CustomizeTempModal = ({
                              modalShow,
                              setModalShow,
                              activeTemplate,
                              content,
                              image1,
                              image2,
                              customizeTextHandler,
                              applyTemplateCustomizations,
                              fileSelectedHandler1,
                              fileSelectedHandler2,
                              preview1,
                              preview2,
                              savingTemplate,
                              resetTemplateHandler
                            }) => {
  const [show, setShow] = useState(false);
  const [showCustomizationPrompt, setShowCustomizationPrompt] = useState(false);
  const customizeTemplateTitle = `Template ${parseInt(activeTemplate) + 1} Customization`;
  const CKEditorCustomProps = {
    form: {
      canEditContent: true
    },
    content,
    customizeTextHandler,
    activeTemplate
  }
  const promptResetTemplate = () => {
    console.log('showing prompt...')
    setShow(true);
  }
  return (
    <>
      {show &&
        <PromptDialog
          onRef={(ref) => {
          }}
          onlyDialog={true}
          title={"Reset Original Template"}
          body={"This will reset content and images you have uploaded to default content. Are you sure you`d like to reset template?"}
          okText={"Yes"}
          cancelText={"No"}
          onOk={() => {resetTemplateHandler();setShow(false)}}
          onCancel={() => setShow(false)}
          show={show}
        />
      }
      {showCustomizationPrompt &&
        <PromptDialog
          onRef={(ref) => {
          }}
          onlyDialog={true}
          title={"Template Customization"}
          body={`You agree to take on the added responsibility that comes from editing or changing the original text or images that were provided. \nOnce you click Yes, your changes will be visible on your 9 To Know application.`}
          okText={"Yes"}
          cancelText={"No"}
          onCancel={() => setShowCustomizationPrompt(false)}
          onOk={() => {applyTemplateCustomizations();setShowCustomizationPrompt(false);}}
          show={showCustomizationPrompt}
        />
      }
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="xl"
        backdrop="static"
        keyboard={false}
        closeButton="false"
        aria-labelledby="templateEditor"
        centered
        className='nine2k_modal'
      >
        <Modal.Header closeButton>
          <Modal.Title id="templateEditor">
            {customizeTemplateTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <section>
            <CKEditor {...CKEditorCustomProps} type="topMid" height="330px"/>
            <Form.Group>
              <Form.File id="image1" label="Upload Image" onChange={fileSelectedHandler1}/>
              {
                activeTemplate !== '3' &&
                <Form.File id="image2" label="Upload Image" onChange={fileSelectedHandler2}/>
              }
              <small className='text-muted'>Please upload your image if you want to replace the default
                placeholder.</small>
              {preview1 && <img src={preview1} alt="Image Preview" width="100"/>}
              {preview2 && <img src={preview2} alt="Image Preview" width="100"/>}
            </Form.Group>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
          <Button style={{'float': 'right'}} onClick={() => promptResetTemplate()}>Reset Original Template</Button>
          <Button onClick={() => setShowCustomizationPrompt(true)}
                  disabled={savingTemplate}>{savingTemplate ? 'Saving...' : 'Apply Customization And Save'}</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CustomizeTempModal
